import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const getAllCommoditities = createAsyncThunk(
  "getAllCommoditities",
  async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/commodity`
      );
      ;
      return data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const CommoditySlice = createSlice({
  name: "Commodities",
  initialState: {
    allCommodities: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: {
    [getAllCommoditities.pending]: (state) => {
      state.status = "pending";
    },
    [getAllCommoditities.fulfilled]: (state, action) => {
      state.status = "success";
      state.error = action.error;
      state.allCommodities = action.payload;
    },
    [getAllCommoditities.rejected]: (state, action) => {
      state.status = "failed";
      state.allCommodities = null;
      state.error = action.error;
    },
  },
});

export default CommoditySlice.reducer;
